// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainform_header__kFK90 {
  margin-bottom: 30px;
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 20px;
}
.mainform_header__kFK90 .mainform_logo__x3C14 {
  flex-shrink: 0;
  margin-top: 10px;
  margin-left: 100px; /* Shift logo to the right side */
}
.mainform_header__kFK90 .mainform_logo__x3C14 .mainform_logoImage__1IcFh {
  width: 100px;
  height: 100px;
  object-fit: contain;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.mainform_header__kFK90 .mainform_right__dc8Sn {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 12px;
  font-weight: bold;
}
.mainform_header__kFK90 .mainform_clear__CjyPw {
  clear: both;
}
.mainform_header__kFK90 .mainform_center__76OXS {
  text-align: center;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  margin-left: -180px; /* Shift content to the left */
}
.mainform_header__kFK90 .mainform_center__76OXS p {
  margin: 3px 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.mainform_header__kFK90 .mainform_center__76OXS p.mainform_universityName__V-eca {
  font-size: 18px;
  font-weight: bold;
  margin: 5px 0;
}
.mainform_header__kFK90 .mainform_center__76OXS p.mainform_officeName__VS7Bq {
  font-size: 16px;
  font-weight: normal;
}
.mainform_header__kFK90 .mainform_center__76OXS p.mainform_officeName__VS7Bq input {
  font-size: 16px;
  font-weight: normal;
  text-align: center;
}
.mainform_header__kFK90 .mainform_center__76OXS p.mainform_officeAddress__QitU4 {
  font-size: 16px;
  font-weight: normal;
}
.mainform_header__kFK90 .mainform_center__76OXS p.mainform_officeAddress__QitU4 input {
  font-size: 16px;
  font-weight: normal;
  text-align: center;
}
.mainform_header__kFK90 .mainform_center__76OXS p.mainform_officeCode__n6MvJ {
  font-size: 16px;
  font-weight: normal;
}
.mainform_header__kFK90 .mainform_center__76OXS p.mainform_officeCode__n6MvJ span {
  white-space: nowrap;
}
.mainform_header__kFK90 .mainform_center__76OXS p.mainform_officeCode__n6MvJ input {
  font-size: 16px;
  font-weight: normal;
  text-align: center;
  min-width: 30px !important;
  max-width: 30px !important;
  width: 30px !important;
}
.mainform_header__kFK90 p {
  margin: 8px 0;
  font-size: 14px;
}

.mainform_mainTitle__CyVfP {
  text-align: center;
  margin: 30px 0;
}
.mainform_mainTitle__CyVfP h1 {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  color: #000;
}

.mainform_formSection__Uc2bK {
  margin: 20px 0;
}
.mainform_formSection__Uc2bK p {
  margin: 12px 0;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.mainform_formSection__Uc2bK .mainform_formRow__yYQ8W {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 12px 0;
  gap: 15px;
}
.mainform_formSection__Uc2bK .mainform_formRow__yYQ8W .mainform_label__UhckP {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  min-width: 140px;
  text-align: right;
}
.mainform_formSection__Uc2bK.mainform_rightAlign__\\+pZpg {
  text-align: right;
}
.mainform_formSection__Uc2bK.mainform_rightAlign__\\+pZpg p {
  justify-content: flex-end;
  text-align: right;
}
.mainform_formSection__Uc2bK.mainform_rightAlign__\\+pZpg p input {
  text-align: right;
}
.mainform_formSection__Uc2bK.mainform_rightAlign__\\+pZpg .mainform_formRow__yYQ8W {
  justify-content: flex-end;
}
.mainform_formSection__Uc2bK.mainform_rightAlign__\\+pZpg .mainform_formRow__yYQ8W .mainform_label__UhckP {
  text-align: right;
}
.mainform_formSection__Uc2bK.mainform_rightAlign__\\+pZpg .mainform_formRow__yYQ8W input {
  text-align: center;
}

input[type=text] {
  border: none;
  min-width: 80px;
  max-width: 400px;
  background: transparent;
  font-family: inherit;
  font-size: inherit;
  text-align: left;
  margin: 0 2px;
  padding: 2px 4px;
  overflow: visible;
  white-space: nowrap;
  transition: width 0.2s ease;
  width: auto;
}
input[type=text]:focus {
  outline: none;
}
input[type=text].mainform_underline__PISLk {
  min-width: 120px;
  max-width: 500px;
  flex: 1 1;
}

.mainform_underline__PISLk {
  width: 100%;
  margin: 10px 0;
}

.mainform_tableContainer__biFFE {
  width: 100%;
  overflow-x: auto;
  margin: 20px 0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  /* Custom scrollbar styles */
  /* Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: #0467a0 #f1f1f1;
}
.mainform_tableContainer__biFFE::-webkit-scrollbar {
  height: 8px;
}
.mainform_tableContainer__biFFE::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.mainform_tableContainer__biFFE::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #0467a0 0%, #ff0000 100%);
  border-radius: 4px;
}
.mainform_tableContainer__biFFE::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #035a8a 0%, #cc0000 100%);
}

.mainform_table__kXNiQ {
  border-collapse: collapse;
  width: 100%;
  min-width: 1400px; /* Ensure minimum width for all columns */
}
.mainform_table__kXNiQ th, .mainform_table__kXNiQ td {
  border: 1px solid #000;
  padding: 10px;
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
  white-space: nowrap; /* Prevent text wrapping */
}
.mainform_table__kXNiQ th {
  background-color: #f2f2f2;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 10;
}
.mainform_table__kXNiQ tbody tr {
  height: 40px;
}
.mainform_table__kXNiQ input[type=text] {
  width: 100%;
  box-sizing: border-box;
  min-width: auto;
  margin: 0;
  border: none;
  text-align: center;
  background: transparent;
  padding: 4px;
  font-size: 14px;
}
.mainform_table__kXNiQ input[type=text]:focus {
  outline: none;
  background: white;
  box-shadow: 0 0 0 1px rgba(4, 103, 160, 0.25);
}

button {
  background: #ff6b6b;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}
button:hover {
  background: #ff5252;
}

.mainform_addRowButton__Zk560 {
  text-align: center;
  margin: 20px 0;
}
.mainform_addRowButton__Zk560 button {
  background: linear-gradient(135deg, #0467a0 0%, #ff0000 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}
.mainform_addRowButton__Zk560 button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  background: linear-gradient(135deg, #035a8a 0%, #cc0000 100%);
}
.mainform_addRowButton__Zk560 button:active {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.mainform_ddd__CYysJ {
  border: 1px solid #000;
  padding: 4px;
}

.mainform_signature__W1QRr {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}
.mainform_signature__W1QRr div {
  width: 30%;
  text-align: left;
}
.mainform_signature__W1QRr .mainform_signature-display__sYyOL {
  margin-top: 10px;
  text-align: center;
}
.mainform_signature__W1QRr .mainform_signature-display__sYyOL img {
  border: 1px solid #ccc;
  border-radius: 4px;
  background: white;
  padding: 2px;
}

.mainform_ddd__CYysJ {
  border: 1px solid #000;
  padding: 4px;
}

.mainform_formActions__w17Lb {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
  padding: 20px 0;
  border-top: 1px solid #dee2e6;
}
.mainform_formActions__w17Lb .mainform_submitBtn__kXYGR, .mainform_formActions__w17Lb .mainform_printBtn__ELoAt {
  padding: 12px 30px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 150px;
}
.mainform_formActions__w17Lb .mainform_submitBtn__kXYGR {
  background: linear-gradient(135deg, #0467a0, #035a8a);
  color: white;
  box-shadow: 0 4px 15px rgba(4, 103, 160, 0.3);
}
.mainform_formActions__w17Lb .mainform_submitBtn__kXYGR:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(4, 103, 160, 0.4);
}
.mainform_formActions__w17Lb .mainform_submitBtn__kXYGR:active {
  transform: translateY(0);
}
.mainform_formActions__w17Lb .mainform_printBtn__ELoAt {
  background: linear-gradient(135deg, #ff0000, #cc0000);
  color: white;
  box-shadow: 0 4px 15px rgba(255, 0, 0, 0.3);
}
.mainform_formActions__w17Lb .mainform_printBtn__ELoAt:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 0, 0, 0.4);
}
.mainform_formActions__w17Lb .mainform_printBtn__ELoAt:active {
  transform: translateY(0);
}
.mainform_formActions__w17Lb .mainform_cancelBtn__DI8ah {
  background: linear-gradient(135deg, #ff0000, #cc0000);
  color: white;
  box-shadow: 0 4px 15px rgba(255, 0, 0, 0.3);
}
.mainform_formActions__w17Lb .mainform_cancelBtn__DI8ah:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 0, 0, 0.4);
}
.mainform_formActions__w17Lb .mainform_cancelBtn__DI8ah:active {
  transform: translateY(0);
}

@media (max-width: 768px) {
  .mainform_header__kFK90 {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  .mainform_header__kFK90 .mainform_logo__x3C14 {
    margin-top: 0;
  }
  .mainform_header__kFK90 .mainform_logo__x3C14 .mainform_logoImage__1IcFh {
    width: 60px;
    height: 60px;
  }
  .mainform_header__kFK90 .mainform_right__dc8Sn {
    position: static;
    text-align: right;
    margin-bottom: 10px;
  }
  .mainform_header__kFK90 .mainform_center__76OXS {
    margin: 15px 0;
  }
  .mainform_mainTitle__CyVfP h1 {
    font-size: 20px;
  }
  .mainform_formSection__Uc2bK p {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  input[type=text].mainform_underline__PISLk {
    min-width: 100%;
  }
  .mainform_tableContainer__biFFE {
    margin: 15px 0;
  }
  .mainform_table__kXNiQ {
    font-size: 12px;
    min-width: 1200px;
  }
  .mainform_table__kXNiQ th, .mainform_table__kXNiQ td {
    padding: 6px;
    font-size: 12px;
  }
  .mainform_signature__W1QRr {
    flex-direction: column;
    gap: 20px;
  }
  .mainform_signature__W1QRr div {
    width: 100%;
  }
  .mainform_formActions__w17Lb {
    flex-direction: column;
    align-items: center;
  }
  .mainform_formActions__w17Lb .mainform_submitBtn__kXYGR, .mainform_formActions__w17Lb .mainform_printBtn__ELoAt {
    width: 100%;
    max-width: 300px;
  }
}
@media (max-width: 480px) {
  .mainform_header__kFK90 .mainform_logo__x3C14 .mainform_logoImage__1IcFh {
    width: 50px;
    height: 50px;
  }
  input[type=text] {
    min-width: 100px;
    font-size: 14px;
  }
  .mainform_tableContainer__biFFE {
    margin: 10px 0;
  }
  .mainform_table__kXNiQ {
    font-size: 11px;
    min-width: 1000px;
  }
  .mainform_table__kXNiQ th, .mainform_table__kXNiQ td {
    padding: 4px;
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/StoreForm/403/mainform.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AACF;AACE;EACE,cAAA;EACA,gBAAA;EACA,kBAAA,EAAA,iCAAA;AACJ;AACS;EACF,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;AACP;AAGE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;AADJ;AAIE;EACE,WAAA;AAFJ;AAKE;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA,EAAA,8BAAA;AAHJ;AAKI;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAHN;AAKM;EACE,eAAA;EACA,iBAAA;EACA,aAAA;AAHR;AAMM;EACE,eAAA;EACA,mBAAA;AAJR;AAMQ;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AAJV;AAQM;EACE,eAAA;EACA,mBAAA;AANR;AAQQ;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AANV;AAUM;EACE,eAAA;EACA,mBAAA;AARR;AAUQ;EACE,mBAAA;AARV;AAWQ;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,0BAAA;EACA,sBAAA;AATV;AAeE;EACE,aAAA;EACA,eAAA;AAbJ;;AAiBA;EACE,kBAAA;EACA,cAAA;AAdF;AAgBE;EACE,eAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AAdJ;;AAkBA;EACE,cAAA;AAfF;AAiBE;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAfJ;AAkBE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,SAAA;AAhBJ;AAkBI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AAhBN;AAoBE;EACE,iBAAA;AAlBJ;AAoBI;EACE,yBAAA;EACA,iBAAA;AAlBN;AAoBM;EACE,iBAAA;AAlBR;AAsBI;EACE,yBAAA;AApBN;AAsBM;EACE,iBAAA;AApBR;AAuBM;EACE,kBAAA;AArBR;;AA2BA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;AAxBF;AA0BE;EACE,aAAA;AAxBJ;AA2BE;EACE,gBAAA;EACA,gBAAA;EACA,SAAA;AAzBJ;;AA6BA;EACE,WAAA;EACA,cAAA;AA1BF;;AA6BA;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,wCAAA;EAEA,4BAAA;EAmBA,sBAAA;EACA,qBAAA;EACA,gCAAA;AA7CF;AAyBE;EACE,WAAA;AAvBJ;AA0BE;EACE,mBAAA;EACA,kBAAA;AAxBJ;AA2BE;EACE,6DAAA;EACA,kBAAA;AAzBJ;AA2BI;EACE,6DAAA;AAzBN;;AAkCA;EACE,yBAAA;EACA,WAAA;EACA,iBAAA,EAAA,yCAAA;AA/BF;AAiCE;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA,EAAA,0BAAA;AA/BJ;AAkCE;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AAhCJ;AAmCE;EACE,YAAA;AAjCJ;AAoCE;EACE,WAAA;EACA,sBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;AAlCJ;AAoCI;EACE,aAAA;EACA,iBAAA;EACA,6CAAA;AAlCN;;AAwCA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,sDAAA;AArCF;AAuCE;EACE,mBAAA;AArCJ;;AAyCA;EACE,kBAAA;EACA,cAAA;AAtCF;AAwCE;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,yCAAA;EACA,sDAAA;AAtCJ;AAwCI;EACE,2BAAA;EACA,0CAAA;EACA,6DAAA;AAtCN;AAyCI;EACE,wBAAA;EACA,yCAAA;AAvCN;;AA4CA;EACE,sBAAA;EACA,YAAA;AAzCF;;AA4CA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAzCF;AA2CE;EACE,UAAA;EACA,gBAAA;AAzCJ;AA4CE;EACE,gBAAA;EACA,kBAAA;AA1CJ;AA4CI;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;AA1CN;;AA+CA;EACE,sBAAA;EACA,YAAA;AA5CF;;AA+CA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AA5CF;AA8CE;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AA5CJ;AA+CE;EACE,qDAAA;EACA,YAAA;EACA,6CAAA;AA7CJ;AA+CI;EACE,2BAAA;EACA,6CAAA;AA7CN;AAgDI;EACE,wBAAA;AA9CN;AAkDE;EACE,qDAAA;EACA,YAAA;EACA,2CAAA;AAhDJ;AAkDI;EACE,2BAAA;EACA,2CAAA;AAhDN;AAmDI;EACE,wBAAA;AAjDN;AAqDE;EACE,qDAAA;EACA,YAAA;EACA,2CAAA;AAnDJ;AAqDI;EACE,2BAAA;EACA,2CAAA;AAnDN;AAsDI;EACE,wBAAA;AApDN;;AA0DA;EACE;IACE,sBAAA;IACA,mBAAA;IACA,SAAA;EAvDF;EAyDE;IACE,aAAA;EAvDJ;EAyDI;IACE,WAAA;IACA,YAAA;EAvDN;EA2DE;IACE,gBAAA;IACA,iBAAA;IACA,mBAAA;EAzDJ;EA4DE;IACE,cAAA;EA1DJ;EA8DA;IACE,eAAA;EA5DF;EA+DA;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;EA7DF;EAgEA;IACE,eAAA;EA9DF;EAiEA;IACE,cAAA;EA/DF;EAkEA;IACE,eAAA;IACA,iBAAA;EAhEF;EAkEE;IACE,YAAA;IACA,eAAA;EAhEJ;EAoEA;IACE,sBAAA;IACA,SAAA;EAlEF;EAoEE;IACE,WAAA;EAlEJ;EAsEA;IACE,sBAAA;IACA,mBAAA;EApEF;EAsEE;IACE,WAAA;IACA,gBAAA;EApEJ;AACF;AAwEA;EAGM;IACE,WAAA;IACA,YAAA;EAxEN;EA6EA;IACE,gBAAA;IACA,eAAA;EA3EF;EA8EA;IACE,cAAA;EA5EF;EA+EA;IACE,eAAA;IACA,iBAAA;EA7EF;EA+EE;IACE,YAAA;IACA,eAAA;EA7EJ;AACF","sourcesContent":[".header {\n  margin-bottom: 30px;\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  \n  .logo {\n    flex-shrink: 0;\n    margin-top: 10px;\n    margin-left: 100px; /* Shift logo to the right side */\n    \n         .logoImage {\n       width: 100px;\n       height: 100px;\n       object-fit: contain;\n       border-radius: 50%;\n       box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n     }\n  }\n  \n  .right {\n    position: absolute;\n    top: 0;\n    right: 0;\n    font-size: 12px;\n    font-weight: bold;\n  }\n\n  .clear {\n    clear: both;\n  }\n\n  .center {\n    text-align: center;\n    margin: 20px 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n    margin-left: -180px; /* Shift content to the left */\n\n    p {\n      margin: 3px 0;\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 1.0;\n      text-align: center;\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 10px;\n      \n      &.universityName {\n        font-size: 18px;\n        font-weight: bold;\n        margin: 5px 0;\n      }\n      \n      &.officeName {\n        font-size: 16px;\n        font-weight: normal;\n        \n        input {\n          font-size: 16px;\n          font-weight: normal;\n          text-align: center;\n        }\n      }\n      \n      &.officeAddress {\n        font-size: 16px;\n        font-weight: normal;\n        \n        input {\n          font-size: 16px;\n          font-weight: normal;\n          text-align: center;\n        }\n      }\n      \n      &.officeCode {\n        font-size: 16px;\n        font-weight: normal;\n        \n        span {\n          white-space: nowrap;\n        }\n        \n        input {\n          font-size: 16px;\n          font-weight: normal;\n          text-align: center;\n          min-width: 30px !important;\n          max-width: 30px !important;\n          width: 30px !important;\n        }\n      }\n    }\n  }\n\n  p {\n    margin: 8px 0;\n    font-size: 14px;\n  }\n}\n\n.mainTitle {\n  text-align: center;\n  margin: 30px 0;\n  \n  h1 {\n    font-size: 24px;\n    font-weight: bold;\n    margin: 0;\n    color: #000;\n  }\n}\n\n.formSection {\n  margin: 20px 0;\n  \n  p {\n    margin: 12px 0;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .formRow {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin: 12px 0;\n    gap: 15px;\n    \n    .label {\n      font-size: 14px;\n      font-weight: 500;\n      white-space: nowrap;\n      min-width: 140px;\n      text-align: right;\n    }\n  }\n\n  &.rightAlign {\n    text-align: right;\n    \n    p {\n      justify-content: flex-end;\n      text-align: right;\n      \n      input {\n        text-align: right;\n      }\n    }\n    \n    .formRow {\n      justify-content: flex-end;\n      \n      .label {\n        text-align: right;\n      }\n      \n      input {\n        text-align: center;\n      }\n    }\n  }\n}\n\ninput[type=\"text\"] {\n  border: none;\n  min-width: 80px;\n  max-width: 400px;\n  background: transparent;\n  font-family: inherit;\n  font-size: inherit;\n  text-align: left;\n  margin: 0 2px;\n  padding: 2px 4px;\n  overflow: visible;\n  white-space: nowrap;\n  transition: width 0.2s ease;\n  width: auto;\n  \n  &:focus {\n    outline: none;\n  }\n\n  &.underline {\n    min-width: 120px;\n    max-width: 500px;\n    flex: 1;\n  }\n}\n\n.underline {\n  width: 100%;\n  margin: 10px 0;\n}\n\n.tableContainer {\n  width: 100%;\n  overflow-x: auto;\n  margin: 20px 0;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  \n  /* Custom scrollbar styles */\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n  \n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n  \n  &::-webkit-scrollbar-thumb {\n    background: linear-gradient(135deg, #0467a0 0%, #ff0000 100%);\n    border-radius: 4px;\n    \n    &:hover {\n      background: linear-gradient(135deg, #035a8a 0%, #cc0000 100%);\n    }\n  }\n  \n  /* Firefox scrollbar */\n  scrollbar-width: thin;\n  scrollbar-color: #0467a0 #f1f1f1;\n}\n\n.table {\n  border-collapse: collapse;\n  width: 100%;\n  min-width: 1400px; /* Ensure minimum width for all columns */\n  \n  th, td {\n    border: 1px solid #000;\n    padding: 10px;\n    text-align: center;\n    vertical-align: middle;\n    font-size: 14px;\n    white-space: nowrap; /* Prevent text wrapping */\n  }\n  \n  th {\n    background-color: #f2f2f2;\n    font-weight: bold;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n  }\n  \n  tbody tr {\n    height: 40px;\n  }\n  \n  input[type=\"text\"] {\n    width: 100%;\n    box-sizing: border-box;\n    min-width: auto;\n    margin: 0;\n    border: none;\n    text-align: center;\n    background: transparent;\n    padding: 4px;\n    font-size: 14px;\n    \n    &:focus {\n      outline: none;\n      background: white;\n      box-shadow: 0 0 0 1px rgba(4, 103, 160, 0.25);\n    }\n  }\n}\n\n// Button styles for remove button\nbutton {\n  background: #ff6b6b;\n  color: white;\n  border: none;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  \n  &:hover {\n    background: #ff5252;\n  }\n}\n\n.addRowButton {\n  text-align: center;\n  margin: 20px 0;\n  \n  button {\n    background: linear-gradient(135deg, #0467a0 0%, #ff0000 100%);\n    color: white;\n    border: none;\n    padding: 12px 24px;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n    \n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n      background: linear-gradient(135deg, #035a8a 0%, #cc0000 100%);\n    }\n    \n    &:active {\n      transform: translateY(0);\n      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    }\n  }\n}\n\n.ddd {\n  border: 1px solid #000;\n  padding: 4px;\n}\n\n.signature {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 40px;\n  \n  div {\n    width: 30%;\n    text-align: left;\n  }\n\n  .signature-display {\n    margin-top: 10px;\n    text-align: center;\n    \n    img {\n      border: 1px solid #ccc;\n      border-radius: 4px;\n      background: white;\n      padding: 2px;\n    }\n  }\n}\n\n.ddd {\n  border: 1px solid #000;\n  padding: 4px;\n}\n\n.formActions {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 40px;\n  padding: 20px 0;\n  border-top: 1px solid #dee2e6;\n\n  .submitBtn, .printBtn {\n    padding: 12px 30px;\n    border: none;\n    border-radius: 25px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    min-width: 150px;\n  }\n\n  .submitBtn {\n    background: linear-gradient(135deg, #0467a0, #035a8a);\n    color: white;\n    box-shadow: 0 4px 15px rgba(4, 103, 160, 0.3);\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 6px 20px rgba(4, 103, 160, 0.4);\n    }\n\n    &:active {\n      transform: translateY(0);\n    }\n  }\n\n  .printBtn {\n    background: linear-gradient(135deg, #ff0000, #cc0000);\n    color: white;\n    box-shadow: 0 4px 15px rgba(255, 0, 0, 0.3);\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 6px 20px rgba(255, 0, 0, 0.4);\n    }\n\n    &:active {\n      transform: translateY(0);\n    }\n  }\n\n  .cancelBtn {\n    background: linear-gradient(135deg, #ff0000, #cc0000);\n    color: white;\n    box-shadow: 0 4px 15px rgba(255, 0, 0, 0.3);\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 6px 20px rgba(255, 0, 0, 0.4);\n    }\n\n    &:active {\n      transform: translateY(0);\n    }\n  }\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .header {\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n    \n    .logo {\n      margin-top: 0;\n      \n      .logoImage {\n        width: 60px;\n        height: 60px;\n      }\n    }\n    \n    .right {\n      position: static;\n      text-align: right;\n      margin-bottom: 10px;\n    }\n\n    .center {\n      margin: 15px 0;\n    }\n  }\n\n  .mainTitle h1 {\n    font-size: 20px;\n  }\n\n  .formSection p {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 5px;\n  }\n\n  input[type=\"text\"].underline {\n    min-width: 100%;\n  }\n\n  .tableContainer {\n    margin: 15px 0;\n  }\n  \n  .table {\n    font-size: 12px;\n    min-width: 1200px;\n    \n    th, td {\n      padding: 6px;\n      font-size: 12px;\n    }\n  }\n\n  .signature {\n    flex-direction: column;\n    gap: 20px;\n    \n    div {\n      width: 100%;\n    }\n  }\n\n  .formActions {\n    flex-direction: column;\n    align-items: center;\n    \n    .submitBtn, .printBtn {\n      width: 100%;\n      max-width: 300px;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .header {\n    .logo {\n      .logoImage {\n        width: 50px;\n        height: 50px;\n      }\n    }\n  }\n  \n  input[type=\"text\"] {\n    min-width: 100px;\n    font-size: 14px;\n  }\n\n  .tableContainer {\n    margin: 10px 0;\n  }\n  \n  .table {\n    font-size: 11px;\n    min-width: 1000px;\n    \n    th, td {\n      padding: 4px;\n      font-size: 11px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `mainform_header__kFK90`,
	"logo": `mainform_logo__x3C14`,
	"logoImage": `mainform_logoImage__1IcFh`,
	"right": `mainform_right__dc8Sn`,
	"clear": `mainform_clear__CjyPw`,
	"center": `mainform_center__76OXS`,
	"universityName": `mainform_universityName__V-eca`,
	"officeName": `mainform_officeName__VS7Bq`,
	"officeAddress": `mainform_officeAddress__QitU4`,
	"officeCode": `mainform_officeCode__n6MvJ`,
	"mainTitle": `mainform_mainTitle__CyVfP`,
	"formSection": `mainform_formSection__Uc2bK`,
	"formRow": `mainform_formRow__yYQ8W`,
	"label": `mainform_label__UhckP`,
	"rightAlign": `mainform_rightAlign__+pZpg`,
	"underline": `mainform_underline__PISLk`,
	"tableContainer": `mainform_tableContainer__biFFE`,
	"table": `mainform_table__kXNiQ`,
	"addRowButton": `mainform_addRowButton__Zk560`,
	"ddd": `mainform_ddd__CYysJ`,
	"signature": `mainform_signature__W1QRr`,
	"signature-display": `mainform_signature-display__sYyOL`,
	"formActions": `mainform_formActions__w17Lb`,
	"submitBtn": `mainform_submitBtn__kXYGR`,
	"printBtn": `mainform_printBtn__ELoAt`,
	"cancelBtn": `mainform_cancelBtn__DI8ah`
};
export default ___CSS_LOADER_EXPORT___;
